import { connect } from 'react-redux';
import Sign from '../components/Sign';
import { flow, property } from 'lodash';
import { startRequest as getCertificateInfo } from '../redux/certificateInfo/actions';
import { startRequest as runChecking } from '../redux/registrationStatus/actions';
import { reset, startRequest as removeCertificate } from '../redux/removeCertificate/actions';
import { startRequest as getPersonalData } from '../redux/personalData/actions';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { remotePaths } from 'router/routes';
import config from 'config';

const mapStateToProps = createStructuredSelector({
  certificateInfo: property('profile.certificateInfo'),
  registrationStatus: property('profile.registrationStatus'),
  inn: flow(property('app.user'), (user) => user.getIn(['data', 'inn'])),
  email: flow(property('app.user'), (user) => user.getIn(['data', 'email'])),
  checkRemoving: property('profile.removeCertificate'),
  personalData: property('profile.personalData'),
  contactInfo: property('profile.contactInfo'),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      goToProfilePage: () => config.goToNewLK(remotePaths.profile),
      checkStatus: runChecking,
      getCertificateInfo: (data) => getCertificateInfo(data),
      removeCertificate: (revokeType, data) => removeCertificate({ revokeType, data }),
      resetCertificateRemoving: reset,
      loadPersonalData: getPersonalData,
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(Sign);
